import getMuiTheme from 'material-ui/styles/getMuiTheme'
const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#002d72',
    primary2Color: '#002d72',
    // primary3Color: 'red',
    // accent1Color: 'red',
    // accent2Color: 'red',
    // accent3Color: 'red',
    // textColor: 'red',
    // alternateTextColor: 'red',
    // canvasColor: 'red',
    // borderColor: 'red',
    // disabledColor: 'red',
    pickerHeaderColor: '#002d72'
    // clockCircleColor: '#002d72',
    // shadowColor: 'red',
  }
})

export default muiTheme



// WEBPACK FOOTER //
// ./src/muiTheme/manole.js